export default class UImageLoader {
  imageInput
  param
  size
  type
  dateevent
  initevent

  static dataURLToBlob (d) {
    var BASE64 = ';base64,'
    var p
    if (d.indexOf(BASE64) === -1) {
      p = d.split(',')
      return new Blob([p[1]], {type: p[0].split(':')[1]})
    }
    p = d.split(BASE64)
    var r = window.atob(p[1])
    var max = r.length
    var u8 = new Uint8Array(max)
    var i = 0
    while (i < max) {
      u8[i] = r.charCodeAt(i)
      i++
    }
    return new Blob([u8], {type: p[0].split(':')[1]})
  }

  static isURL (d) {
    return d.indexOf('data:image') === -1
  }

  static changeTrance (data, r, g, b) {
    var step = 6
    for (var i = 0; i < data.length; i += 4) {
      if (data[i] < r + step && data[i] > r - step) {
        if (data[i + 1] < g + step && data[i + 1] > g - step) {
          if (data[i + 2] < b + step && data[i + 2] > b - step) {
            data[i + 3] = 0
          }
        }
      }
    }
  }

  getResizeImg (c, i, w, h) {
    if (w !== 0 && i.width > w) {
      i.height *= w / i.width
      i.width = w
    }
    if (h !== 0 && i.height > h) {
      i.width *= h / i.height
      i.height = h
    }
    c.width = i.width
    c.height = i.height
    console.log(c.width, c.height)
    c.getContext('2d').drawImage(i, 0, 0, i.width, i.height)
  }

  changeUrlToCanvas (id, url, getimg) {
    var i = new Image()
    i.src = url
    i.onload = (e) => {
      this.changeImgToCanvas(id, i, getimg)
    }
  }

  changeImgToCanvas (id, img, getimg) {
    var c = document.createElement('canvas')
    console.log(typeof this.size)
    var _id = id.split('_input')[0]
    if (this.size) {
      switch (typeof this.size) {
        case 'number' :
          this.getResizeImg(c, img, this.size, this.size)
          break
        default :
          this.getResizeImg(c, img, this.size.width, this.size.height)
          break
      }
    } else {
      this.getResizeImg(c, img, img.width, img.height)
    }
    if (this.dataevent) {
      this.dataevent[_id](_id, c, this.param, this.type)
    }
    if (this.initevent) {
      switch (this.type) {
        case 'png':
          this.initevent[_id](_id, c.toDataURL('image/png'), this.param, this.type)
          break
        default:
          this.initevent[_id](_id, c.toDataURL('image/jpeg'), this.param, this.type)
          break
      }
    }
    if (getimg) {
      switch (this.type) {
        case 'png':
          getimg(_id, c.toDataURL('image/png'), this.param, this.type)
          break
        default:
          getimg(_id, c.toDataURL('image/jpeg'), this.param, this.type)
          break
      }
    }
  }

  loadImg (id, f, getimg) {
    var fr = new FileReader()
    fr.onload = (e) => {
      this.changeUrlToCanvas(id, e.target.result, getimg)
    }
    console.log(f)
    fr.readAsDataURL(f)
  }

  addForm (node, id, change) {
    // var f = document.createElement('form')
    // f.id = id
    // f.classList.add('hide')
    // f.method = 'post'
    // f.enctype = 'multipart/form-data'
    // f.action = '/api/image'
    if (this.imageInput === null || this.imageInput === undefined) {
      this.imageInput = {}
    }
    var input = document.createElement('input')
    input = document.createElement('input')
    input.classList.add('hide')
    input.type = 'file'
    input.id = id + '_input'
    input.name = input.id
    input.accept = 'image/*'
    input.capture = 'camera'
    input.onchange = (e) => {
      console.log('onchange', e)
      this.loadImg(e.target.id, e.target.files[0], change)
      e.target.value = null
    }
    console.log(this.imageInput, id, input)
    this.imageInput[id] = input
    // f.appendChild(input)
    node.appendChild(input)
  }
  // type === 'init', 'data'
  addEvent (type, id, func) {
    switch (type) {
      case 'init':
        if (this.initevent === null || this.initevent === undefined) {
          this.initevent = {}
        }
        this.initevent[id] = func
        break
      case 'data':
        if (this.dataevent === null || this.dataevent === undefined) {
          this.dataevent = {}
        }
        this.dataevent[id] = func
        break
    }
  }

  open (id, size, param, type) {
    this.param = param
    console.log(this.size, size)
    if (size !== undefined && size !== null) {
      this.size = size
    }
    this.type = type
    this.imageInput[id].click()
  }
}



// WEBPACK FOOTER //
// ./src/components/js/UImageLoader.js